import { showToast } from "./shared/utils/message";

const toastMessageTypeEle = document.querySelector<HTMLInputElement>('#GLOBAL_TOAST_MESSAGE_TYPE');
const toastMessageEle = document.querySelector<HTMLInputElement>('#GLOBAL_TOAST_MESSAGE');
if (toastMessageEle && toastMessageTypeEle) {
    showToast(toastMessageTypeEle.value, toastMessageEle.value);
}

function clearActive() {
    document.getElementsByName('selectLoginWay').forEach((item) => {
        item.classList.remove('active');
    });
}

function bindEvent() {
    let btn_aside_extend = window.document.getElementById('btn-main-aside-extend');
    if (btn_aside_extend) {
        btn_aside_extend.onclick = () => {
            let main_aside = window.document.getElementById('t-app-aside');
            if (main_aside.className.indexOf('t-miniature') != -1) {
                main_aside.classList.remove('t-miniature');
            } else {
                main_aside.classList.add('t-miniature');
            }
        };
    }
}
bindEvent();